import { createContext } from "react";
export const AuthenticationContext = createContext();
export const MessageContext = createContext();
export const GridViewContext = createContext();
export const GridViewHeaderContext = createContext();
export const GridViewRowContext = createContext();
